import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {
    feedFetch,
    feedFiltersFetch,
    userFollowSuggestions,
    topicTrendingListFetch,    
    trackerTodayFetch,
    tapArticlesFetch
} from '../../actions/index';
import {mobileCheck, gtmSend} from '../../helpers';
import { getUrlParameter, readCookie, spu_createCookie } from '@tickled-media/web-components.tm-helpers';
import { translate } from 'react-i18next';
import cx from '../../styles';
// import style from './style.css';
import BaseLayout from '../../components/Layout/BaseLayout';
import FeedContainer from '../Feed';
import FeedSwitcherComponent from '../../components/Layout/Sidebars/FeedSwitcher';
import FeedSwitcherMobile from '../../components/Layout/Sidebars/FeedSwitcher/Mobile';
import UserFollowSuggestionsSidebar from '../../components/Layout/Sidebars/UserFollowSuggestions';
// import TopicTrendingListSidebar from '../../components/Layout/Sidebars/TopicList';
// import TrackerSidebar from '../../components/Layout/Sidebars/Tracker';
import ArticleListSidebar from '../../components/Layout/Sidebars/ArticleList';
// import { adCoreInit } from '../../components/Ads/Bootstrap';
import AdPlaceholder from '../../components/Ads/Placeholder';
import AdCoreSlot from '../../components/Ads/AdCoreSlot';
import TrackerCardBanner from '../../components/AppDownload/TrackerCardBanner';
//import QuestionAnsGif from '../../components/AppDownload/QuestionAnsGif';
import Breadcrumbs from '../../components/Layout/Breadcrumbs';
import BirthClubModal from '../../components/BirthClubModal';
import { isBeYeuTemplate } from '../../config';

class HomePageContainer extends Component {

    constructor(props) {
        super(props);
        // this.state = {};
        //
        // this.dfpArr = [];
        this.state = {
            filter: getUrlParameter('type') || 'home_feed', 
            subfilter: 'newsfeed', 
            rightSidebar: [], 
            filterId: getUrlParameter('id') || 0,
            isModalOpen: false
        };
        //ads
        /*if(typeof window != 'undefined') {
            let ads = this.props.configReducer.ads;
            if(props.appReducer.deviceType == 'desktop') {
                this.dfpArr = [
                    {networkId: ads.networkId, unit: ads.common.half_page.unit, id: ads.common.half_page.id, size: [ads.common.half_page.w, ads.common.half_page.h], collapse: true}
                ];
            } else {
                // this.dfpArr = [
                //     {networkId: ads.networkId, unit: ads.mobile.top.unit, id: ads.mobile.top.id, size: [ads.mobile.top.w, ads.mobile.top.h], collapse: true}
                // ];
            }        
            adCoreInit(this.dfpArr);
        }   */     

    }

    componentDidMount() {
        //gtm
        // gtmSend('view homepage', 'home', 'view', this.props.appReducer.deviceType);
        //sidebars
        this.requestSidebars();
        this.buildRightSidebar();
        const {feedReducer, userReducer, location} = this.props;
        if(feedReducer && feedReducer.widget && feedReducer.widget.target_url && readCookie('birthclub_popup') !== this.props.feedReducer.widget.target_url){
            document.cookie = `birthclub_popup=; expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${process.env.REACT_APP_ENV == 'development' ? 'localhost' : '.theasianparent.com'};path=/`;
            this.setState({isModalOpen: true});
        }
        //to prevent dynamic feed
        if(feedReducer.accessedFrom === location.pathname && feedReducer.currentFeed === 'newsfeed' && feedReducer.currentFilter === 'home_feed') return false;
        //needed because filled feeds are allowed to switch and cant check on empty
        if(!feedReducer.ifServerFilled || feedReducer.accessedFrom === '/' || feedReducer.currentFeed !== 'newsfeed'){
            this.props.feedFetch('newsfeed', 1, true, location.pathname, this.state.filter, this.state.filterId)
            if(this.props.userReducer.id){
                this.props.feedFiltersFetch();
            }
        }
        //check for onboarding
        if(userReducer.id && (userReducer.stepRegister > 0)) {
            this.redirect('/onboarding');
        }        
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.filter !== this.state.filter || prevState.filterId !== this.state.filterId){
            this.props.feedFetch('newsfeed', 1, true, this.props.location.pathname, this.state.filter, this.state.filterId)
        }

        if(this.props.feedReducer && this.props.feedReducer.widget && this.props.feedReducer.widget.target_url !== prevProps.feedReducer.widget.target_url){
            if(this.props.feedReducer.widget.target_url && readCookie('birthclub_popup') !== this.props.feedReducer.widget.target_url){
                document.cookie = `birthclub_popup=; expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${process.env.REACT_APP_ENV == 'development' ? 'localhost' : '.theasianparent.com'};path=/`;
                this.setState({isModalOpen: true});
            }
            else{
                this.setState({isModalOpen: false});
            }
        }
    }

    componentWillReceiveProps (nextProps) {
        if (isBeYeuTemplate && nextProps.userReducer.stepRegister != this.props.userReducer.stepRegister) {
            if (nextProps.userReducer.id && (nextProps.userReducer.stepRegister > 0)) {
                this.redirect('/onboarding');
            }
        }
    }

    switchFeed = (filter, subfilter, path, filterId) => {
        this.setState({filter, subfilter, filterId});
        this.redirect(path, filter, filterId);
    }

    redirect = (pathname, filter, filterId, state=null) => {
        this.props.history.replace({
            pathname,
            search:  (['poll','hash'].indexOf(filter) === -1 && (filter != undefined || filterId != undefined))
                ? `?type=${filter}&id=${filterId}&lng=${this.props.appReducer.locale}` : '',
            ...(state && {state})
        });
    }

    onModalClose = () => {
        gtmSend('dynamic', 'Birth club - close', 'click', '');
        spu_createCookie('birthclub_popup', this.props.feedReducer && this.props.feedReducer.widget ? this.props.feedReducer.widget.target_url : '', 24);
        this.setState({isModalOpen: false});
    }

    requestSidebars = () => {
        if(!mobileCheck() && !this.props.appReducer.topicsTrendingSidebar.length){
            this.props.topicTrendingListFetch();
        }

        if(!this.props.appReducer.userFollowSuggestionsSidebar.length && this.props.userReducer.id) {
            this.props.userFollowSuggestions();
        }

        // !this.props.appReducer.trackerSidebar && this.props.trackerTodayFetch();
        !this.props.appReducer.articleListSidebar.length && this.props.tapArticlesFetch('suggested');
    }

    buildAdSlots = () => {
        const ads = this.props.configReducer.ads;
        return [
            ads.networkId &&
            <div className={cx("shadow-card")}>
                <AdCoreSlot networkId={ads.networkId} 
                    adUnit={ads.common.half_page.unit}
                    styleClass={ads.common.half_page.styleClass}
                    size={[ads.common.half_page.w, ads.common.half_page.h]}
                    id={ads.common.half_page.id}/>
            </div>
        ];  
    }

    buildLeftSidebar = () => {
        /*let trendingListSidebarComponent =
            <div className={cx("shadow-card", !this.props.appReducer.topicsTrendingSidebar.length && 'hide')}>
                <TopicTrendingListSidebar topics={this.props.appReducer.topicsTrendingSidebar} />
            </div>;*/
        const {appReducer} = this.props;
        const lc = [
            <FeedSwitcherComponent trendingTopicsElems={appReducer.topicsTrendingSidebar} appReducer={appReducer} />
        ];
        /*
            false && appReducer.trackerSidebar &&
            <TrackerSidebar type="portrait" data={appReducer.trackerSidebar} isLoggedOut={!this.props.userReducer.id} />
        */

        return lc;
    }

    buildRightSidebar = () => {
        /*let appDownloadCreative =
            <div className={cx("shadow-card")}>
                <a href="https://community.theasianparent.com/app/download?utm_source=community-static-banner&utm_medium=web&utm_campaign=app-download">
                    <img src={this.props.configReducer['region'].staticAd3} alt="TAPApps_launch" loading="lazy"/>
                </a>
            </div>*/

        const adSlots = this.buildAdSlots();
        const rightSidebar = this.props.appReducer.deviceType === 'desktop' ? adSlots : [];
        
        this.setState({rightSidebar});
    }   

    render(){
        // const siteUrl = this.props.configReducer.siteUrl;
        const { t, history, match, landingUrl, serverReqCookie, appReducer, userReducer, configReducer, feedReducer } = this.props;

        return (
            <BaseLayout history={history}
                className={"posts-listing-page"}
                match={match}
                landingUrl={landingUrl}
                serverReqCookie={serverReqCookie}
                leftCards={this.buildLeftSidebar()}
                rightCards={
                    this.state.rightSidebar.length 
                    ? 
                    [
                        ...this.state.rightSidebar,
                        appReducer.articleListSidebar && appReducer.articleListSidebar.length > 0 &&
                        <ArticleListSidebar articles={appReducer.articleListSidebar} length={6} match={match}/>
                    ] 
                    : 
                    [
                        <div className={cx("shadow-card")}><AdPlaceholder w="320" h="250"/></div>,   
                        appReducer.articleListSidebar && appReducer.articleListSidebar.length > 0 &&
                        <ArticleListSidebar articles={appReducer.articleListSidebar} length={6} match={match}/>
                    ]} 
            >
                
                {/*
                    appReducer.trackerSidebar && mobileCheck() &&
                    <TrackerSidebar type="landscape" data={appReducer.trackerSidebar} isLoggedOut={!userReducer.id} />
                */}
               
                <FeedSwitcherMobile
                    currentFilter={this.state.filter}
                    currentSubFilter={this.state.subfilter}
                    currentFilterId={this.state.filterId}
                    onClickHandler={this.switchFeed}
                    filtersList={feedReducer.filtersList}
                    appReducer={appReducer}
                    userReducer={userReducer}
                    match={match}
                    t={t}
                />
               
                <FeedContainer {...this.props} 
                    injectElem={ (userReducer.id && appReducer.userFollowSuggestionsSidebar && appReducer.userFollowSuggestionsSidebar.length > 0) ? <UserFollowSuggestionsSidebar elems={appReducer.userFollowSuggestionsSidebar} /> : '' } 
                    trackerCardBanner={ (bannerType, designType) => <TrackerCardBanner bannerType={bannerType} designType={designType} appReducer={appReducer} configReducer={configReducer} />}
                />

                <Breadcrumbs links={[
                    {location: '/feed', label: 'Home'},
                    {location: '/feed', label: 'Feed'},
                ]} />

                {/*   
                    mobileCheck() &&
                    <div>
                        <QuestionAnsGif 
                            appReducer={appReducer} 
                            configReducer={configReducer}
                        />
                    </div>
                */}

                <BirthClubModal
                    isModalOpen={this.state.isModalOpen}
                    onModalClose={this.onModalClose}
                    feedReducer={feedReducer}
                    t={t}
                />                
            </BaseLayout>
        );
    }
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        feedFetch,
        feedFiltersFetch,
        userFollowSuggestions,
        topicTrendingListFetch,        
        trackerTodayFetch,
        tapArticlesFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(HomePageContainer));
